// ## italics: true 斜体
// ## blod 加粗
// ## alignment: 'center' 文字居中
// ## alignment: 'justify', 单行字间距相等
// ## width height 宽高
// ## margin: [0, 190, 0, 80] 外边距
// ## opacity: 0.5
// ## pageBreak: 'after' 稍后分页？？
// ## fit: [200, 200] 放在一个矩形内
// ## page numbers 页码
// ## page count 页数
// ##	pageMargins: [ 30, 60, 30, 60 ], 页面边距

// #### 
// 说明：超声报告单独打印模板，只打印超声所见，不打印皮肤镜、CT、大体图所见。
// #### 

export  const reportDataBc = {
	pageMargins: [ 30, 75, 30, 75 ],
	header: [
		{ 	
            id:"header",
			columns: [
                    // 只起空行作用
                	{
					text: [{text: ' ', fontSize: 12, bold: true}],
					alignment: 'left',
					style:'title'					
				    },

				// {
				// 	text: [{text: '检查编号：', fontSize: 12, bold: true}],
				// 	alignment: 'left',
				// 	style:'title'					
				// },
				// {
				// 	text:[{text: '检查单位：', fontSize: 12, bold: true}],
				// 	alignment: 'right',
				// 	style:'title'
				// },
			]
		},
		{ canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] }
	],
	footer:{type:'function', arguments:"currentPage, pageCount",body:`return [
				{ canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] },
				{
					columns: [
						{
							text: '检查医生：',
							style:['patientsInfo','titleMargin']
						},

						{
							text: '报告日期：',
                            style:['patientsInfo','titleMargin'],
                            width:'30%'                            
						},
						{
							text: '页码：'+currentPage.toString() + '/' + pageCount,
							style:['patientsInfo','titleMargin'],
							alignment: 'right'
						},
					],
					margin: [30,0,30,0]
				},
				{text:"（本报告单内容仅供参考，如有不符请及时与检查医生联系）", alignment: 'left',fontSize: 8,margin: [30,5,30,0]}
			];`
	 },//  function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },
	content: [
		{   
            id:"patientsName",
			columns: [
				{
					text: [{text: '姓名：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '性别：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: [{text: '年龄：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text:[{text: 'ID号：',  bold: true}],
                    style:'patientsInfo',
                    width:'30%'
				},
			]
		},
		{
            id:"patientsDoctor",
			columns: [
				{
					text:[{text: '申请医生：',  bold: true}],
					style:['patientsInfo','titleMargin'],
				},
				{
					text:[{text: '申请单位：',  bold: true}],
					style:['patientsInfo','titleMargin'],
					width:'47%'
				},
				// {
				// 	text:[{text: '申请日期：',  bold: true}] ,
                //     style:['patientsInfo','titleMargin'],
                //     width:'30%'                    
				// },
			]
		},
		{
            id:"patientsClinical",
			columns: [
				{
					text: [{text: '临床诊断：',  bold: true}],
					style:['patientsInfo','titleMargin'],
				},
				{
					text: '',
					style:['patientsInfo','titleMargin'],
					width:'480'
				},
			]
		},

        // 一般情况
		{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		// {
		// 	text:[{text: '一般情况',fontSize:12,  bold: true}] ,
		// 	style:['patientsInfo','titleMargin']
		// },
		// {   
        //     id:"complaint",
		// 	columns: [
		// 		{
		// 			text: [{text: '主诉：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
        // },
        // {   
        //     id:"disease_history_before",
		// 	columns: [
		// 		{
		// 			text: [{text: '既往史：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
        // },
        // {
        //     id:"disease_history_present",
		// 	columns: [
		// 		{
		// 			text: [{text: '现病史：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
        // },
        // {
        //     id:"lab",
		// 	columns: [
		// 		{
		// 			text:[{text: '实验室：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
		// },
		// {
        //     id:"disease_history_family",
		// 	columns: [
		// 		{
		// 			text: [{text: '家族史：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
		// },
        // 一般情况（主诉、现病史、既往史等）后面的横杠
		//{ canvas: [ { type: 'line', x1: 0, y1: 6, x2: 540, y2: 6,lineWidth:0.5 } ] },
		
        {
            id:"aboveImage",
			text:"",
			margin:[0,10,0,0]
		},
		{
			// text: [{text: '影像观察', fontSize:12, bold: true}],
            // 空一行
            text: [{text: '  ', fontSize:12, bold: true}],
			style:['patientsInfo','titleMargin']
		},
		// {
        //     id:"general",
		// 	columns: [
		// 		{
		// 			text:[{text: '大体图/伍德灯：', bold: true}],
		// 			style:['patientsInfo','DTT']
		// 		},
		// 		{
		// 			text: '',
		// 			width:'460'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
		// },
		// {   id:"skin",
		// 	columns: [
		// 		{
		// 			text: [{text: '皮肤镜：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
		// },
		// {  
        //     id:"ct",
		// 	columns: [
		// 		{
		// 			text:[{text: 'CT：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
        // },
        {
            id:"bc",
			columns: [
				{
					text: [{text: '超声所见：',  bold: true}],
					style:'patientsInfo'
				},
				{
					text: '',
					width:'480'
				},
			],
			style:['patientsInfo','titleMargin'],
			width:'480'
        },
        // {
        //     id:"bl",
		// 	columns: [
		// 		{
		// 			text: [{text: '病理：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
        // },
      
		
		// {
		// 	image:'test1.jpg',
		// 	fit: [400, 250],
		// 	alignment: 'center'
		// },
		// {
		// 	text:"大体图",
		// 	alignment: 'center',
		// 	style:['patientsInfo','titleMargin']
		// },
		// {
		// 	columns: [
		// 		{
		// 			image:'test1.jpg',
		// 			fit: [200, 200],
		// 			alignment: 'center',
		// 		},
		// 		{
		// 			image:'test1.jpg',
		// 			fit: [200, 200],
		// 			alignment: 'center'
		// 		},
		// 	]
		// },
		// {	
		// 	columns:[
		// 		{text:"大体图",alignment: 'center',style:['patientsInfo','titleMargin']},
		// 		{text:"大体图",alignment: 'center',style:['patientsInfo','titleMargin']}
		// 	]
		// },
		// {
		// 	columns: [
		// 		{
		// 			image:'test1.jpg',
		// 			fit: [200, 200],
		// 			alignment: 'center',
		// 		},
		// 		{
		// 			text:'',
		// 			fit: [200, 200],
		// 			alignment: 'center',
		// 		},
		// 	]
		// },
		// {	
		// 	columns:[
		// 		{text:"大体图",alignment: 'center',style:['patientsInfo','titleMargin']},
		// 		{text:"",alignment: 'center',style:['patientsInfo','titleMargin']}
		// 	]
		// },
		{
			id:"diagnoseResult",
			text:'',
			width:'480'
		},
		// {
        //     id:"advise",
		// 	columns: [
		// 		{
		// 			text:[{text: '建议：',  bold: true}],
		// 			style:'patientsInfo'
		// 		},
		// 		{
		// 			text: '',
		// 			width:'480'
		// 		},
		// 	],
		// 	style:['patientsInfo','titleMargin'],
		// 	width:'480'
		// }
	],
	styles: {
		title:{
			margin: [30,5],
			fontSize: 12,
			// bold: false
		},
		titleMargin:{
			margin:[0,2,0,0]
		},
		DTT:{
			width:50
		},
		patientsInfo:{
			fontSize: 10
		},
		small: {
			fontSize: 8
		}
	}
	
};